import { onDestroy } from 'svelte';


/** utils for components **/
export function css(node, style = {}) {
	const stylesheet = node.style
	Object.entries(style).forEach((elem) => {
	  stylesheet[elem[0]] = elem[1]
	})
  }
  export function register(node, events) {
	const eventTypes = Object.keys(events)
	eventTypes.forEach((key) => node.addEventListener(key, events[key]))
	return () => {
	  eventTypes.forEach((key) => node.removeEventListener(key, events[key]))
	}
  }
  
  export function classNames(...args) {
	return args
	  .filter((o) => o)
	  .map((o) => {
		if (typeof o === 'string') {
		  return o.trim()
		}
		return Array.from(Object.entries(o))
		  .map(([e1, e2]) => {
			if (e2) {
			  if (typeof e2 === 'boolean') {
				return e1
			  }
			  return `${e2?.trim()} ${e1}`
			}
			return ''
		  })
		  .filter((o) => o)
		  .join(' ')
		  .trim()
	  })
	  .filter((o) => o)
	  .join(' ')
	  .trim()
  }

  

export function onInterval(callback, milliseconds, forceRun = false) {
	let start = 0 ,last = 0, elapsed = 0;
	const step = (timestamp) =>{
		if(!start){
			start = last = timestamp

			if(forceRun)
				callback()
		}
		else
			elapsed +=  timestamp - last
		
		if(elapsed >= milliseconds){
			elapsed = elapsed%milliseconds
			callback()
		}
		
		last = timestamp
		interval = requestAnimationFrame(step)
	}
	var interval = requestAnimationFrame(step);

	const _destroy = () => {
		cancelAnimationFrame(interval);
	}

	return _destroy

	//onDestroy(_destroy);
}
/** object utilities */

// Iterates over all own properties of an object, running a callback for each one
export const forOwn = (obj, fn) =>
  Object.keys(obj).forEach(key => fn(obj[key], key, obj));


  
/////


/** math and number utils **/

export const getRandomIntInclusive = (min, max) => {
	min = Math.ceil(min);
	max = Math.floor(max);
	return Math.floor(Math.random() * (max - min + 1) + min); //The maximum is inclusive and the minimum is inclusive
  }

/// end math and number utils ///



/** bet math **/

const factorial = n => !(n > 1) ? 1 : factorial(n - 1) * n;

const calcMinesPayout = ( mines, diamonds) => {
	house_edge = 0.01
    let f1 = factorial(25) / (factorial(diamonds) * factorial(25 - diamonds));
    let f2 = factorial(25-mines) / (factorial(diamonds) * factorial( (25-mines) - diamonds));
 	 return Math.round((1 - house_edge) * (f1/f2) * 100) / 100
}

/** Misc **/

// wait, returns promise which resolves after ms milliseconds
export function wait(ms = 1000){
    return new Promise((resolve, reject) => { setTimeout(() => resolve(), Math.abs(ms) )})
}

// Example POST method implementation:
export const postData = async function (url = "", data = {}, config) {

	// Default options are marked with *
	const response = await fetch(url, {
		method: "POST", // *GET, POST, PUT, DELETE, etc.
		mode: "cors", // no-cors, *cors, same-origin
		cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
		credentials: "omit", // include, *same-origin, omit
		headers: {
			... {
				"Content-Type": "application/json",
				//'Content-Type': 'application/x-www-form-urlencoded',		
			},
			... config.headers
		},
		redirect: "follow", // manual, *follow, error
		referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
		body: JSON.stringify(data), // body data type must match "Content-Type" header
	}).then(res => res.json());
	return response; // parses JSON response into native JavaScript objects
}